import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { filter, take } from 'rxjs/operators'
import { isSomething } from '@tokeet-frontend/tv3-platform'
import { AirbnbSyncSettingsDialogComponent } from './airbnb-sync-settings-dialog.component'

@Injectable({
  providedIn: SharedModule,
})
export class AirbnbSyncSettingsDialogService {
  constructor(private dialog: MatDialog) {}

  public open(channelId: string) {
    const defaultConfig: MatDialogConfig = {
      width: '400px',
      height: 'auto',
      data: { channelId },
      panelClass: ['fixed-modal'],
    }

    return this.dialog
      .open(AirbnbSyncSettingsDialogComponent, defaultConfig)
      .afterClosed()
      .pipe(
        take(1),
        filter((res) => isSomething(res))
      )
  }
}
